import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
import type { FormEvent } from 'react';
import { authApi, type SignupPayload } from '../utils/apiClient';

function SignupPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const payload: SignupPayload = { name, email, password };
    const result = await authApi.signup(payload);
    console.log('Signup response', result);
    setLoading(false);

    if (!result.success) {
      setError(result.error);
      toast.error(result.error);
      return;
    }

    // localStorage.setItem('signupResponse', JSON.stringify(result.data));
    toast.success('Account created successfully');
    navigate('/verify');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white px-6 py-12">
      <div className="w-full max-w-xl space-y-8 text-slate-900">
        <div className="text-center space-y-2">
          <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Carewinners Admin</p>
          <h1 className="text-3xl font-semibold text-slate-900">Create a new account</h1>
          <p className="text-slate-600 text-sm">
            Register your team credentials to access scheduling, reports, and compliance dashboards.
          </p>
        </div>
        <div className="bg-white border border-emerald-200 rounded-3xl p-10 shadow-2xl space-y-6">
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1" htmlFor="name">
                Full name
              </label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(event) => setName(event.target.value)}
                placeholder="Jordan Rivera"
                className="w-full rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-slate-900 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-400/60"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1" htmlFor="email">
                Work email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@carewinners.org"
                className="w-full rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-slate-900 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-400/60"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Enter password"
                className="w-full rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-slate-900 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-400/60"
                required
              />
            </div>
            {error && (
              <p className="text-sm text-center text-rose-600" aria-live="assertive">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-2xl bg-[#78C45E] text-white font-semibold text-sm transition hover:bg-[#78C45E]/90 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {loading ? 'Creating account...' : 'Create account'}
            </button>
          </form>
          <p className="text-center text-xs text-slate-500">
            Already have an account?{' '}
            <Link to="/" className="text-emerald-600 underline decoration-emerald-400 hover:text-emerald-500">
              Sign in instead
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignupPage;
